import { render, staticRenderFns } from "./ContractsDisplayer.vue?vue&type=template&id=a3ac86a4&scoped=true&"
import script from "./ContractsDisplayer.vue?vue&type=script&lang=ts&"
export * from "./ContractsDisplayer.vue?vue&type=script&lang=ts&"
import style0 from "./ContractsDisplayer.vue?vue&type=style&index=0&id=a3ac86a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ac86a4",
  null
  
)

export default component.exports